/**
 * Inyecta el `ApiClient` en el árbol. Ninguna vista lo construye por su
 * cuenta: hay uno solo por sesión y es el que serializa los refresh.
 *
 * El contexto y el hook `useApi` viven en `useApi.ts` — ver el comentario de
 * ese archivo para el porqué.
 */
import type { ReactNode } from 'react';

import type { ApiClient } from './client';
import { ApiContext } from './useApi';

export function ApiProvider({
  client,
  children,
}: {
  client: ApiClient;
  children: ReactNode;
}): ReactNode {
  return <ApiContext.Provider value={client}>{children}</ApiContext.Provider>;
}
